<!--  -->
<template>
  <div class="home">
  		<van-nav-bar
            left-arrow
            fixed
            @click-left="$router.go(-1)">
        </van-nav-bar>
        <div class="fail">{{$t('OrderDetail.cashPay')}}</div>	  
  </div>
</template>

<script>
export default {
  data () {
    return {
    };
  },
}

</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
        font-size: 26px;
        color: #fff;
    }
	.home{
        width: 100%;
        height: 100vh;
        background-color: #fff;
    }
    .fail{
		text-align: center;
		margin-top:100px;
		line-height: 40px;
		font-size: 30px;
		color: #2f75f4;
		font-weight: bold;
		background: #fff;
	}
</style>


// WEBPACK FOOTER //
// src/components/CashPayment.vue